import React from 'react';

import Steps from '../steps/Steps.js';
import Networks from '../networks/Networks.js';
import Asset from '../asset/Asset.js';
import ProposeClaim from '../proposeClaim/ProposeClaim.js';
import MakeTransfer from '../makeTransfer/MakeTransfer.js';
import ClaimAsset from '../claimAsset/ClaimAsset.js';
import ProposeBurn from '../proposeBurn/ProposeBurn.js';

import { Modal } from 'rsuite';

import './Bridge.css';

function useOutsideAlerter(ref, setShow) {
    React.useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                setShow(false);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, setShow]);
}

function Bridge(props) {

    const networks = ['ethereum', 'astral', 'binance'];
    const assets = [
	    ['DAI', 'maker dao'],
	    ['USDT', 'tether usd'],
	    ['GHST', 'ghost token']
    ];

    const [show, setShow] = React.useState(false);
    const [step, setStep] = React.useState(1);
    const [network, setNetwork] = React.useState(networks[0]);
    const [asset, setAsset] = React.useState(assets[0][0]);
    const [rangeValue, setRangeValue] = React.useState(0);
    const [toOrFrom, setToOrFrom] = React.useState(true);
    const backdrop = true;

    const change = () => {
        setShow(!show);
    }

    const handleRangeChange = (event) => {
        setRangeValue(event.target.value);
    }

    const findAssetName = (asset) => {
        for (let i = 0; i < assets.length; i++) {
	    if (assets[i][0] === asset) {
	        return assets[i][1];
	    }
	}
    }

    const wrapperRef = React.useRef(null);
    useOutsideAlerter(wrapperRef, setShow);

    return (
	<React.Fragment>
	    <div onClick={() => change()} className="ghost-header-button">Bridge</div>

	    <Modal onHide={change} show={show} backdrop={backdrop}>
                <div ref={wrapperRef} className="ghost-birdge-container">
	            <div className="ghost-bridge-main">
	                {step === 1 ?
			    <Networks step={step} setStep={setStep} network={network} setNetwork={setNetwork} networks={networks} toOrFrom={toOrFrom} setToOrFrom={setToOrFrom} />
			    :
			    step === 2 ? <Asset step={step} setStep={setStep} asset={asset} setAsset={setAsset} assets={assets} /> :
			    step === 3 ? 
				toOrFrom ? 
				<ProposeClaim step={step} setStep={setStep} asset={asset} assetName={findAssetName(asset)} network={network} rangeValue={rangeValue} handleRangeChange={handleRangeChange} /> :
				<ProposeBurn step={step} setStep={setStep} asset={asset} assetName={findAssetName(asset)} network={network} rangeValue={rangeValue} handleRangeChange={handleRangeChange} />
				:
			   step === 4 ? <MakeTransfer step={step}  setStep={setStep} asset={asset} assetName={findAssetName(asset)} network={network} rangeValue={rangeValue} /> : 
			   <ClaimAsset step={step} setStep={setStep} asset={asset} assetName={findAssetName(asset)} network={network} rangeValue={rangeValue} />
			}
	            </div>
	            
	            <Steps step={step} setStep={setStep} toOrFrom={toOrFrom} />
                </div>
	    </Modal>
	</React.Fragment>
    )
}

export default Bridge;
